{
  "campaignName": "Cores",
  "platform": "Tori Finance",
  "description": "Points for providing liquidity.",
  "platformImageId": "tori.png",
  "dashboardLink": "https://app.tori.finance/opportunities/",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xb723a224c9ACF3891B20437B4d55dd45600F5FA3",
      "network": "ethereum",
      "multiplier": "30x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x25a637C80AD90177d0B3fF28aa2D3F74F7165ccb",
      "network": "ethereum",
      "multiplier": "15x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xd1D954BC94c843815EC7b8119f2de00AF27Fa6Ff",
      "network": "ethereum",
      "multiplier": "30x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xEe7A6849982026DEd35c2Aa510319AFe5a0801A8",
      "network": "monad",
      "multiplier": "15x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xD665CaAD68ACb093AFF27eC6c71Ccc4F29c28147",
      "network": "monad",
      "multiplier": "30x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
